import React from "react";
import { useLang } from "../../i18n";
import { MaskLine } from "../../lib/motion.jsx";
import { MembershipForm } from "../../components/MembershipForm";

const PROGRAMS = [
  { value: "FC Inkad Diegem - U6", label: "FC Inkad Diegem · U6", fee: 300 },
  { value: "FC Inkad Diegem - U7", label: "FC Inkad Diegem · U7", fee: 300, full: true },
  { value: "FC Inkad Diegem - U8", label: "FC Inkad Diegem · U8", fee: 300, full: true },
  { value: "FC Inkad Diegem - U9", label: "FC Inkad Diegem · U9", fee: 300, full: true },
  { value: "FC Inkad Diegem - U10", label: "FC Inkad Diegem · U10", fee: 300, full: true },
  { value: "FC Inkad Diegem - U11", label: "FC Inkad Diegem · U11", fee: 300 },
  { value: "FC Inkad Diegem - U12", label: "FC Inkad Diegem · U12", fee: 300, full: true },
  { value: "FC Inkad Diegem - P4", label: "FC Inkad Diegem · P4", fee: 300 },
  { value: "FC Inkad Diegem - Veteranen", label: "FC Inkad Diegem · Veteranen", fee: 200 },
];

export default function FcInschrijven() {
  const { t } = useLang();
  return (
    <div className="fc-theme min-h-screen" data-testid="fc-inschrijven">
      <section className="border-b border-white/10 bg-gradient-to-b from-[#141414] to-[#0A0A0A] pt-24 pb-14">
        <div className="mx-auto max-w-3xl px-6">
          <span className="text-[11px] uppercase tracking-[0.3em] text-[#CCFF00]">FC Inkad</span>
          <h1 className="font-anton text-5xl md:text-7xl uppercase leading-none mt-3"><MaskLine>{t("regFcTitle")}</MaskLine></h1>
          <p className="mt-5 text-white/60">{t("regFcLead")}</p>
        </div>
      </section>
      <div className="mx-auto max-w-3xl px-6 py-14">
        <div className="border border-white/10 bg-[#141414] p-6 md:p-10 rounded-sm">
          <MembershipForm branch="fc-inkad" programs={PROGRAMS} multiple={false} />
        </div>
      </div>
    </div>
  );
}
